import urls from '../api_urls/BASFProduct.js'

import { _post } from '../request.js'

// 获取basf product列表数据
export function getTableData (params) {
  return _post(urls.list, params)
}

// 获取basf product列表数据(管理后台)
export function getManagementData (params) {
  return _post(urls.managementList, params)
}

// productPrd
export function getProductPrd (params) {
  return _post(urls.productPrd, params)
}

// productName
export function getProductName (params) {
  return _post(urls.productName, params)
}

export function getInci (params) {
  return _post(urls.getInci, params)
}

export function getDetail (params) {
  return _post(urls.getDetail, params)
}

export function getManagementDetail (params) {
  return _post(urls.getManagementDetail, params)
}

// 审批通过
export function approveTradeName (params) {
  return _post(urls.approve, params)
}

// 撤回
export function withdraw (params) {
  return _post(urls.withdraw, params)
}

// count
export function getCount (params) {
  return _post(urls.getCount, params)
}

// tradeName新增
export function addTradeName (params) {
  return _post(urls.add, params)
}

// tradename编辑update
export function updateTradeName (params) {
  return _post(urls.update, params)
}

// tradename导出
export function exportTradeName (params) {
  return _post(urls.export, params)
}

// 获取inciName
export function getInciName (params) {
  return _post(urls.getInciName, params)
}

// 禁用/启用
export function enableOperate (params) {
  return _post(urls.enableOperate, params)
}

// 设置Key focus product
export function setKeyProduct (params) {
  return _post(urls.setKeyProduct, params)
}

// 设置Sample Request
export function setSampleRequest (params) {
  return _post(urls.setSampleRequest, params)
}

// 获取上传tab数字
export function getUploadTradeCount (params) {
  return _post(urls.getUploadTradeCount, params)
}

export function deleteDraft (params) {
  return _post(urls.deleteDraft, params)
}



// WEBPACK FOOTER //
// ./src/axios/api/BASFProduct.js